import React, { useCallback, useEffect, useRef, useState, } from 'react'
import { Row, Col, Button, } from 'reactstrap'
import PropTypes from 'prop-types'
import ProgramTagList from '../Search/ProgramSearch/ProgramTagList'
import styled from 'styled-components'

const DetailOccupation = styled.h1`
  font-family: "Noto Sans", Arial, Helvetica, sans-serif !important;
  font-weight: bold;
  font-size: 2.25rem;
  color: #000000;
`

const DetailHeader = ({
  occupationName = '',
  programName = '',
  programTags,
  baseWage,
  programLength = '',
  startDate = '',
  endDate = '',
  headerTags,
  hasApplicationInfo = false,
  onHowToApplyClick,
  onResourcesClick,
}) => {
  const [ copied, setCopied, ] = useState(false)
  const timeoutRef = useRef(null)

  const onCopyClick = useCallback((e) => {
    e.preventDefault()
    const tr = timeoutRef
    // if there's not already a timeout going, make one to re-enable the button after 5s
    if (tr != null && tr !== undefined && (tr.current == null || tr.current === undefined)) {
      navigator.clipboard.writeText(window.location.href).then(() => setCopied(true))
      //reset button, store timeout
      // @ts-ignore
      tr.current = setTimeout(() => {
        const ref = tr
        if (ref != null && ref !== undefined && ref.current != null && ref.current !== undefined) {
          setCopied(false)
          ref.current = null
        }
      }, 5000)
    }
  }, [ setCopied, ])

  useEffect(() => {
    return () => {
      const tr = timeoutRef
      if (tr != null && tr !== undefined && tr.current != null && tr.current !== undefined) {
        clearTimeout(tr.current)
      }
    }
  }, [])

  return <>
    <Row className={'justify-content-between pb-0 pb-md-4'}>
      <Col lg={8} xs={12} className={'align-top'}>
        <DetailOccupation  className={'heading-2 align-top mt-5'}>{occupationName}</DetailOccupation>
        <h2 className={'heading-3-grey mb-3 mb-lg-5 align-top'}>{programName}</h2>
      </Col>
      <Col lg={4} xs={12} className={'mt-3 mt-lg-0'}>
        {
          (programTags != null && programTags !== undefined && programTags.length > 0) &&
          <Row>
            <Col className={'mt-2 program-type'} xs={12}>
              {programTags}
            </Col>
          </Row>
        }
        {
          (baseWage != null && baseWage !== undefined && !isNaN(baseWage) && baseWage > 0) &&
          <Row className={'mb-2'}>
            <Col xs={12}>
              <span className={'text-md-right body-text-bold'}>Wage: </span>
              <span className={'text-left body-text-grey'}>
                ${baseWage.toFixed(2)} an hour
              </span>
            </Col>
          </Row>
        }
        {
          (programLength != null && programLength !== undefined && programLength !== '') &&
          <Row className={'mb-2'}>
            <Col xs={12}>
              <span className={'text-md-right body-text-bold'}>Program Length: </span>
              <span className={'text-left body-text-grey'}>{programLength}</span>
            </Col>
          </Row>
        }
        {
          (startDate != null && startDate !== undefined && startDate !== '') &&
          <Row className={'mb-2'}>
            <Col xs={12}>
              <span className={'text-md-right body-text-bold'}>Start Date: </span>
              <span className={'text-left body-text-grey'}>
                {startDate}
              </span>
            </Col>
          </Row>
        }
        {
          (endDate != null && endDate !== undefined && startDate !== '') &&
          <Row>
            <Col xs={12}>
              <span className={'text-md-right body-text-bold'}>End Date: </span>
              <span className={'text-left body-text-grey'}>
                {endDate}
              </span>
            </Col>
          </Row>
        }
      </Col>
    </Row>
    <Row className={'mt-2 mt-md-4 tall'}>
      <Col lg={6} xs={12} className={'program-header-details mt-4 mt-md-0 mb-2'}>
        {
          (headerTags && headerTags.length > 0) &&
          <ProgramTagList tags={headerTags} />
        }
      </Col>
      <Col lg={6} xs={12} className={'text-center d-flex align-items-end justify-content-end'}>
        {
          (hasApplicationInfo === true && onHowToApplyClick != null && onHowToApplyClick !== undefined) &&
          <Button
            className={'mt-4 mt-md-0 btn-lg ml-1'}
            onClick={onHowToApplyClick}
          >How to Apply</Button>
        }
        {
          (onResourcesClick != null && onResourcesClick !== undefined) &&
          <Button
            className={'mt-4 mt-md-0 btn-lg ml-1'}
            onClick={onResourcesClick}
          >Additional Resources</Button>
        }
        <Button className={'btn-inverted ml-2'} onClick={onCopyClick}>
          {!copied ? <i className={'fas fa-share-alt fa-lg'}></i> : 'Link Copied'}
        </Button>
      </Col>
    </Row>
  </>
}

DetailHeader.propTypes = {
  occupationName    : PropTypes.string,
  programName       : PropTypes.string,
  programTags       : PropTypes.array,
  baseWage          : PropTypes.oneOfType([ PropTypes.string, PropTypes.number, ]),
  programLength     : PropTypes.string,
  startDate         : PropTypes.string,
  endDate           : PropTypes.string,
  headerTags        : PropTypes.array,
  onHowToApplyClick : PropTypes.func,
  hasApplicationInfo: PropTypes.bool,
  onResourcesClick  : PropTypes.func,
}

export default DetailHeader